import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { KpiUserAssignmentsResponseModel } from '@/types'

export const getKpiUserAssignments = async (
  branchName?: string,
  year?: number,
  quarter?: number,
  userId?: string
): Promise<KpiUserAssignmentsResponseModel[]> => {
  try {
    const response = await axios.get(`${BASE_URL}/kpi/user-assignments`, {
      params: {
        ...(branchName && { branch_name: branchName }),
        ...(year && { year: year }),
        ...(quarter && { quarter: quarter }),
        ...(userId && { user_id: userId }),
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
